export function imagePostFunction(image, src) {
    const img = image.getImage();
    if (typeof window.btoa === "function") {
        const xhr = new XMLHttpRequest();
        const dataEntries = src.split("&");
        let url;
        let params = "";
        for (let i = 0; i < dataEntries.length; i++) {
            if (i === 0) url = dataEntries[i];
            else params += "&" + dataEntries[i];
        }

        xhr.open("POST", url, true);
        xhr.responseType = "arraybuffer";

        xhr.onload = function () {
            if (this.status === 200) {
                const u = new Uint8Array(this.response);
                const strings = [];
                for (let i = 0; i < u.length; i++) strings.push(String.fromCharCode(u[i]));
                const data = strings.join("");
                const type = xhr.getResponseHeader("content-type");
                if (type.indexOf("image") === 0) {
                    img.src = `data:${type};base64,${window.btoa(data)}`;
                }
            }
        };

        const apiKey = `${(<any>window).mapIrKey}`

        xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
        xhr.setRequestHeader("x-api-key", apiKey)
        xhr.send(params);
    } else {
        img.src = src;
    }
}
